module.exports = __webpack_public_path__ + "img/undraw_certification_aif8.a9e6f797.svg";